import React from 'react';
import { Link } from 'react-router-dom';
import { FiretreeLogo } from './FiretreeLogo';
export function Footer() {
  return <footer className="bg-brand-charcoal text-brand-cream py-12" data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-30">
          <div className="col-span-1 md:col-span-2" data-id="element-31">
            <div className="brightness-0 invert mb-6 inline-block" data-id="element-32">
              <FiretreeLogo data-id="element-33" />
            </div>
            <p className="text-brand-shape max-w-md text-sm leading-relaxed" data-id="element-34">
              Firetree offers funders curated access to established,
              high-capacity local organizations with proven models in Southeast
              Asia.
            </p>
          </div>

          <div data-id="element-35">
            <h3 className="font-serif text-lg mb-4 text-brand-gold" data-id="element-36">Explore</h3>
            <ul className="space-y-2 text-sm text-brand-shape" data-id="element-37">
              <li data-id="element-38">
                <Link to="/how-we-work" className="hover:text-white transition-colors" data-id="element-39">
                  How We Work
                </Link>
              </li>
              <li data-id="element-40">
                <Link to="/our-process" className="hover:text-white transition-colors" data-id="element-41">
                  Our Process
                </Link>
              </li>
              <li data-id="element-42">
                <Link to="/who-we-fund" className="hover:text-white transition-colors" data-id="element-43">
                  Who We Fund
                </Link>
              </li>
              <li className="pl-4 border-l border-brand-shape/30 ml-1" data-id="element-44">
                <Link to="/child-protection" className="hover:text-white transition-colors text-brand-shape/80" data-id="element-45">
                  Child Protection
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-46">
            <h3 className="font-serif text-lg mb-4 text-brand-gold" data-id="element-47">Connect</h3>
            <ul className="space-y-2 text-sm text-brand-shape" data-id="element-48">
              <li data-id="element-49">
                <Link to="/engage" className="hover:text-white transition-colors" data-id="element-50">
                  Engage With Us
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/contact" className="hover:text-white transition-colors" data-id="element-52">
                  Contact
                </Link>
              </li>
              <li data-id="element-53">
                <a href="https://firetree.org/team" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-54">
                  Meet the Team ↗
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-brand-brown/40 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-brand-brown" data-id="element-55">
          <p data-id="element-56">
            &copy; {new Date().getFullYear()} Firetree. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}